module.exports = __webpack_public_path__ + "img/dljy-banner.9426dbff.jpg";